import useStore from "../Zustand/Zustand";
import ZustandSelectBankType from "../Zustand/ZustandSelectBankType";
import axios from "axios";

const BASEURL = "https://api-monetare-inter-financiamento.azurewebsites.net/api/inter/simulacao";

export function InterCgiApi({ prazoMesesCgi, valorEmprestimo, valorImovelCgi }) {
  const { adicionarSimulacao, setLoading } = useStore.getState();
  const { setDisableSelectdInter } = ZustandSelectBankType.getState();

  setLoading(true);

  axios.post(
    BASEURL,
    {
      cliente: {
        dataNascimento: "2000-01-01",
      },
      tipoProduto: "HOME_EQUITY",
      quantidadeParcelas: prazoMesesCgi,
      valorSolicitado: valorEmprestimo,
      imovel: {
        valor: valorImovelCgi,
        categoria: "CASA_RESIDENCIAL_ISOLADA",
        estado: "MG",
      },
    },
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  )
    .then((response) => {
      adicionarSimulacao(response.data);
      setDisableSelectdInter(true);
    })
    .catch((error) => {
      console.error("Erro na requisição para calcular:", error);
    })
    .finally(() => {
      setLoading(false)
    });
}

